export default "__VITE_ASSET__CwNhULPs__"